import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import Modal from "./Modal";
import Heroicon from "./Heroicon";

function ConfirmDeletionModal({ route, title, description }) {
  let [isOpen, setIsOpen] = useState(false);
  let [loading, setLoading] = useState(false);

  const tokenSelector = document.head.querySelector('meta[name="csrf-token"]');
  const csrfToken = tokenSelector ? tokenSelector.content : "";

  return (
    <>
      <button
        className="text-xs sm:text-sm btn-outlined btn-red"
        onClick={() => setIsOpen(true)}
      >
        {title}
      </button>

      <Modal title={title} isOpen={isOpen} closeModal={() => setIsOpen(false)}>
        <p className="p-4 m-4 text-sm rounded-md sm:text-base alert alert--danger">
          <img
            src="/assets/icons/icon-danger.svg"
            alt=""
            aria-hidden="true"
            className="w-6 h-6 mr-3 sm:w-10 sm:h-10"
          />
          {description}
        </p>
        <form
          className="flex flex-wrap justify-between gap-2 px-6 py-4 mt-6 bg-gray-200"
          action={route}
          method="POST"
        >
          <input type="hidden" name="_method" value="DELETE" />
          <input type="hidden" name="_token" value={csrfToken} />

          <button
            className="btn-solid btn-red"
            onClick={() => setLoading(true)}
          >
            {title}
            {loading && (
              <Heroicon
                icon="o-arrow-path"
                style="w-4 h-4 inline ml-1 animate-spin"
              />
            )}
          </button>

          <button
            onClick={(e) => {
              e.preventDefault();
              setIsOpen(false);
            }}
            className="inline-block btn-solid btn-dark"
          >
            Close
          </button>
        </form>
      </Modal>
    </>
  );
}

const initConfirmDeletionModal = function (selector) {
  const elements = document.querySelectorAll(selector);
  if (elements.length > 0) {
    elements.forEach((element) => {
      const root = createRoot(element);
      const route = element.dataset.route;
      const title = element.dataset.title;
      const description = element.dataset.description;
      root.render(
        <ConfirmDeletionModal
          route={route}
          title={title}
          description={description}
        />
      );
    });
  }
};

export { ConfirmDeletionModal as default, initConfirmDeletionModal };
